//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import {mapGetters, mapState} from 'vuex'
import { asyncDataStart } from '~/utils/asyncData'
import { Breadcrumbs } from '~/plugins/breadcrumbs'
import BoatCardBlog from '~/components/Boats/card/boat-card-blog.vue'
import RequestAction from '~/components/global/RequestAction.vue'
import SocialButton from '~/components/Boats/SocialButton'
import sectionIndex from '~/components/section/index/section.vue'
import { SocialButtonService } from '~/utils/services/socialService'
import dayjs from '~/modules/dayjs'
import BlogMenu from '~/components/section/blog-menu'
import BlogSearch from '~/components/form/blog-search'
import { capitalizeFirstLetter } from '~/utils/utils'
import OtherLocations from '~/components/seo/other-locations.vue'
const _social = new SocialButtonService()
import OffersInMailbox from '~/components/section/offers-in-mailbox'

export default {
  name: 'BlogsArticle',
  components: {
    BlogSearch,
    BlogMenu,
    OtherLocations,
    SocialButton,
    RequestAction,
    BoatCardBlog,
    sectionIndex,
    OffersInMailbox
  },
  async asyncData (ctx) {
    await asyncDataStart(ctx)
    const breadcrumbs = []
    const lang = ctx.store.getters['lang/locale']
    try {
      let page = null
      const { data } = await ctx.$axios.get('/api/blogs/article/' + ctx.route.params.category + '/' + ctx.route.params.blogSlug + '?lang=' + lang)
      page = data

      if (Object.keys(page).length === 0) {
        return await ctx.redirect(301, `/${lang}/blog/${page.category.slug}/`)
      }
      if (ctx.route.params.blogSlug !== page.data.slug) {
        return await ctx.redirect(301, `/${lang}/blog/${page.category.slug}/${page.data.slug}/`)
      }

      breadcrumbs.push({
        title: 'Blogs',
        url: `${lang}/blog/`
      })

      breadcrumbs.push({
        title: page.category.title,
        url: `${lang}/blog/${page.category.slug}/`
      })

      breadcrumbs.push({
        title: page.data.title || page.name,
        url: `${lang}/blog/${page.category.slug}/${page.data.slug}/`
      })

      const crubms = await Breadcrumbs.get(ctx.app.i18n, 'page', ctx.route, breadcrumbs)
      await ctx.store.dispatch('setBreadcrumbs', crubms)
      ctx.store.commit('SET_META_HEAD', {
        title: page.data?.meta_title,
        meta: [
          { name: 'title', property: 'og:title', hid: 'title', content: page.data?.meta_title },
          { name: 'description', property: 'og:description', hid: 'description', content: page.data?.description },
          { name: 'twitter:title', content: page.data?.meta_title },
          { name: 'twitter:image', content: page.image },
          { property: 'og:image', content: page.image },
          { name: 'author', content: 'Tubber' },
          { name: 'twitter:description', content: page.data?.description }
        ],
        link: []
      })
      return {
        lang,
        page
      }
    } catch (e) {
      return await ctx.redirect(301, `/${lang}/blog/${ctx.route.params.category}/`)
    }
  },
  data () {
    return {
      socialButtons: {
        messenger: _social.getConfig('messenger'),
        facebook: _social.getConfig('facebook'),
        copylink: _social.getConfig('copylink'),
        whatsapp: _social.getConfig('whatsapp'),
        twitter: _social.getConfig('twitter'),
        email: _social.getConfig('email'),
        sms: _social.getConfig('sms')
      },
      similar: [],
      also: {
        loaded: 0,
        loading: true,
        data: [],
        params: {
          currency: null
        }
      }
    }
  },
  head () {
    return {
      title: this.page?.data.meta_title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          property: 'og:description',
          content: this.page?.data.description
        }
      ],
      link: [
        ...this.getAlternate
      ]
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$Search.resetAllAttributes(true)
    next()
  },
  computed: {
    ...mapState({
      windowBreakpoint: 'breakpoint'
    }),
    ...mapGetters({
      check: 'auth/user'
    }),
    getAlternate () {
      return this.page?.data?.alternate.map((alt) => {
        return {
          rel: 'alternate',
          hreflang: alt.lang,
          href: alt.url
        }
      }) || []
    },
    locationSlug () {
      if (this.page.locations && this.page.locations.length) {
        return this.page.locations[0].data
      }
      return ''
    },
    boatTypes () {
      return this.$store.state.search.staticBoatTypes.map((t) => {
        return {
          ...t,
          name: t.translate ? capitalizeFirstLetter(this.$t(t.name.toLowerCase())) : t.name
        }
      })
    },
    getAlsoLike () {
      if (this.also.data?.length) {
        return this.also.data
      }
      return []
    },
    menuCategories () {
      return this.page.categories.filter((cat) => {
        return cat.in_menu === 1
      })
    },
    getSearchTermsAlso () {
      if (this.also?.data?.length && this.also.data[0].start_date) {
        const start_date_parts = this.also.data[0].start_date.split('-')
        const end_date_parts = this.also.data[0].end_date.split('-')
        const start_date = new Date(+start_date_parts[2], start_date_parts[1] - 1, +start_date_parts[0])
        const end_date = new Date(+end_date_parts[2], end_date_parts[1] - 1, +end_date_parts[0])

        return {
          ...this.searchTerms,
          start_date: dayjs(start_date).format('YYYY-MM-DD'),
          end_date: dayjs(end_date).format('YYYY-MM-DD')
        }
      }
      return {
        ...this.searchTerms
      }
    },
    getSliderSettingsAlso: app => (name) => {
      const SETTINGS = {
        also: {
          slidesToShow: 1,
          arrows: false,
          dots: false,
          responsive: [
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
                dots: true,
                arrows: false
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                dots: true,
                arrows: false
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                dots: false,
                arrows: true
              }
            }
          ]
        }
      }
      return {
        ...SETTINGS[name]
      }
    },
    getSliderSettings: app => (name) => {
      const isSlider = app.$store.state.breakpoint.screen.widthMinCalc <= 1024
      const SETTINGS = {
        'discover-flotilla': {
          isSlider: true,
          settings: {
            arrows: false,
            slidesToShow: 1,
            responsive: [
              {
                breakpoint: 576,
                settings: {
                  slidesToShow: 2,
                  arrows: false
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 2,
                  arrows: false,
                  dots: true
                }
              },
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  dots: false,
                  arrows: true
                }
              }
            ]
          }
        }
      }
      return {
        body: {
          isSlider,
          settings: {
            type: 'slider',
            gaps: {
              value: 24
            }
          },
          ...SETTINGS[name]
        }
      }
    }
  },
  methods: {
    async fetchAlsoLike (isVisible) {
      if (!isVisible) {
        return
      }
      if (this.also.loaded) {
        return
      }
      if (this.page.locations && this.page.locations.length) {
        this.also.loaded = true
        this.also.loading = true
        const response = await this.$axios.get(`${process.env.apiUrl}/api/blogs/boats/${this.page.locations[0].data.slug}`, {
          params: {
            lang: this.lang
          }
        })
        this.also.data = response.data.results
        this.also.loading = false
      }
      let cat = ''
      this.page.blogCategories.forEach((c, i) => {
        cat += (i > 0 ? ',' : '') + c.id
      })
      const similar = await this.$axios.get(`${process.env.apiUrl}/api/blogs/similar`, {
        params: {
          lang: this.lang,
          id: this.page.id,
          cat
        }
      })
      this.similar = similar.data
    }
  }
}
